import Vue from 'vue'
import VueRouter from 'vue-router'
import NewsPage from '../vue/pages/News.vue'

export default {
	init() {
		Vue.use(VueRouter)
		const routes = [
			// { path: '/', redirect: '/all' },
			{ path: '/', name: 'home', component: NewsPage },
			// { path: '/:slug', name: 'cat', component: NewsPage },
		]
		const router = new VueRouter({
			mode: 'history',
			routes,
			base: '/news-activities',
		})
		new Vue({
			el: '.main-content',
			router,
		})
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
